import request from '../../utils/request';
import options from './options';

const urlPath = (url, path) => `${url}${path}`;

export const getCalculatorsDegreeOfSoil = filter => request.get({
    url: urlPath(options.apiUrl, filter)
});

export const getCalculatorsDegreeOfSoilItem = id => request.get({
    url: urlPath(options.apiUrl, `${id}/`)
});